export const MINIMUM_NUMBER_OF_ORDERS_TO_DISPLAY = 10;

export const formatNumberOfOrders = (numberOfOrders: number): string => {
  if (numberOfOrders < MINIMUM_NUMBER_OF_ORDERS_TO_DISPLAY) {
    return '';
  }

  if (numberOfOrders < 50) {
    return '10+';
  }

  if (numberOfOrders < 100) {
    return '50+';
  }

  if (numberOfOrders < 1000) {
    // Round to nearest 50
    const rounded = Math.floor((numberOfOrders + 25) / 50) * 50;
    return `${rounded}+`;
  }

  if (numberOfOrders < 10000) {
    // Format as decimal with 1 decimal place
    const value = (numberOfOrders / 1000.0).toFixed(1);
    return `${value}K+`;
  }

  if (numberOfOrders < 100000) {
    // Integer division by 1000
    const value = Math.floor(numberOfOrders / 1000);
    return `${value}K+`;
  }

  if (numberOfOrders < 1000000) {
    // Round to nearest 10K, then display in K
    const rounded = (Math.floor((numberOfOrders + 5000) / 10000) * 10000) / 1000;
    return `${rounded}K+`;
  }

  // Format as decimal millions with 1 decimal place
  const value = (numberOfOrders / 1000000.0).toFixed(1);
  return `${value}M+`;
};
